import { HttpClient } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import {
    Translation,
    TranslocoLoader,
    TranslocoModule,
    provideTransloco,
} from '@jsverse/transloco';
import { Observable } from 'rxjs';

/**
 * Custom HTTP Loader for Transloco.
 * Uses constructor injection — field-level inject() triggers NG0203 when this
 * service is instantiated during standalone-component injector hydration.
 */
@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    constructor(private http: HttpClient) {}

    getTranslation(lang: string): Observable<Translation> {
        return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
    }
}

/**
 * Transloco Configuration Provider
 * Use this in your app configuration (main.ts or app.config.ts)
 */
export const translocoConfig = provideTransloco({
    config: {
        availableLangs: [
            { id: 'en', label: 'English' },
            { id: 'fr', label: 'Français' },
        ],
        defaultLang: 'en',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
        fallbackLang: 'en',
        missingHandler: {
            // Log missing keys in development
            logMissingKey: true,
            useFallbackTranslation: true,
        },
    },
    loader: TranslocoHttpLoader,
});

/**
 * Export TranslocoModule for standalone components
 */
export { TranslocoModule };
